export const headCellStyle = {
  height: 40,
  padding: '0 18px',
  fontSize: '12px',
  fontWeight: 500,
  color: '#424242',
  backgroundColor: '#FAFAFA',
  borderBottom: '1px solid #E0E0E0',
  textTransform: 'uppercase',
  whiteSpace: 'nowrap'
};

export const bodyCellStyle = {
  height: 40,
  padding: '0 18px',
  fontSize: '13px',
  color: '#424242',
  borderBottom: '1px solid #EEEEEE'
};

export const selectSx = {
  height: 36,
  bgcolor: '#fff',
  color: '#757575',
  fontSize: 13,

  '& .MuiSelect-select': {
    py: '7px'
  },

  '& .MuiOutlinedInput-notchedOutline': {
    borderColor: '#D9D9D9'
  },

  '&:hover .MuiOutlinedInput-notchedOutline': {
    borderColor: '#BDBDBD'
  },

  '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
    borderColor: '#5697D4'
  }
};

export const selectMenuProps = {
  PaperProps: {
    elevation: 0,
    sx: {
      mt: 0.5,
      bgcolor: '#FFF8E8',
      border: '1px solid #E8D7A8',
      borderRadius: '6px',
      boxShadow: '0 4px 10px rgba(0,0,0,0.12)',

      '& .MuiMenu-list': {
        p: 0
      },

      '& .MuiMenuItem-root': {
        minHeight: 40,
        px: 2,
        bgcolor: '#FFF8E8',
        color: '#424242',
        fontSize: 13,
        fontWeight: 400,

        '&:hover': {
          bgcolor: '#F5DDAE'
        },

        '&.Mui-focusVisible': {
          bgcolor: '#F5DDAE'
        },

        '&.Mui-selected': {
          bgcolor: '#F6E7B8',
          fontWeight: 500
        },

        '&.Mui-selected:hover': {
          bgcolor: '#EFD18F'
        }
      }
    }
  }
};

export const inputSx = {
  '& .MuiOutlinedInput-root': {
    height: 38,
    fontSize: 13,
    borderRadius: '4px',
    bgcolor: '#fff'
  },

  '& .MuiInputBase-input': {
    fontSize: 13,
    color: '#424242'
  },

  '& .MuiInputBase-input::placeholder': {
    color: '#757575',
    opacity: 1
  }
};

export const formControlSx = {
  '& .MuiInputLabel-root': {
    fontSize: 13,
    color: '#757575'
  },

  '& .MuiInputLabel-root.Mui-focused': {
    color: '#1976D2'
  },

  '& .MuiOutlinedInput-root': {
    height: 38,
    borderRadius: '4px',
    fontSize: 13,
    bgcolor: '#fff'
  },

  '& .MuiSelect-select': {
    py: 1.2
  }
};



export const dialogPaperSx = {
  borderRadius: '4px',
  overflow: 'hidden'
};

export const dialogHeaderSx = {
  px: 1.5,
  py: 1,
  position: 'relative',
  borderBottom: '1px solid #E0E0E0'
};

export const dialogTitleSx = {
  fontSize: 17,
  fontWeight: 500,
  color: '#424242'
};

export const dialogSubtitleSx = {
  mt: 0,
  fontSize: 12,
  color: '#424242'
};

export const closeButtonSx = {
  position: 'absolute',
  top: 22,
  right: 16,
  color: '#424242'
};

export const dialogContentSx = {
  p: 1.5
};

export const formWrapperSx = {
  display: 'grid',
  gap: 2
};

export const sectionTitleSx = {
  fontSize: 13,
  fontWeight: 500,
  color: '#424242',
  textTransform: 'uppercase'
};

export const issueNoteSx = {
  '& .MuiOutlinedInput-root': {
    alignItems: 'flex-start',
    borderRadius: '4px',

    '& .MuiInputBase-input': {
      fontSize: 12,
      color: '#424242'
    }
  },

  '& .MuiInputLabel-root': {
    fontSize: 12,
    color: '#757575'
  },


};

// export const dialogActionsSx = {
//   px: 2.5,
//   py: 2,
//   gap: 1.5,
//   borderTop: '1px solid #E0E0E0'
// };

// export const cancelButtonSx = {
//   height: 38,
//   px: 2,
//   fontSize: 13,
//   fontWeight: 500,
//   color: '#616161',
//   textTransform: 'uppercase'
// };

// export const createButtonSx = {
//   height: 38,
//   px: 2,
//   fontSize: 13,
//   fontWeight: 500,
//   textTransform: 'uppercase',
//   borderRadius: '4px',
//   bgcolor: '#5697D4',
//   boxShadow: 'none',

//   '&:hover': {
//     bgcolor: '#1976D2',
//     boxShadow: 'none'
//   },

//   '&.Mui-disabled': {
//     bgcolor: '#E9E9E9',
//     color: '#BDBDBD'
//   }
// };




export const filterSelectSx = {
  width: 240,
  height: 38,
  bgcolor: '#fff',
  color: '#757575',
  borderRadius: '4px',
  fontSize: 12,

  '& .MuiSelect-select': {
    py: 1
  }
};

export const menuProps = {
  slotProps: {
    paper: {
      sx: {

        borderRadius: '4px',
        boxShadow: '0px 4px 16px rgba(0,0,0,0.16)',

        '& .MuiMenu-list': {
          p: 0
        },

        '& .MuiMenuItem-root': {
          minHeight: 36,
          fontSize: 12,
          color: '#757575',

          '&:hover': {
            bgcolor: '#FCF8F2'
          },

          '&.Mui-selected': {
            bgcolor: '#fff'
          },

          '&.Mui-selected:hover': {
            bgcolor: '#FCF8F2'
          },

          '&.Mui-focusVisible': {
            bgcolor: '#FCF8F2'
          }
        }
      }
    }
  }
};